import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 46 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_d_11512_209233)" }, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.91895",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#B82025"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "6.5",
    y: "7.41895",
    width: "33",
    height: "33",
    rx: "5.78571",
    stroke: "white",
    "stroke-width": "3",
    fill: "#B82025"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_11512_209233",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "8",
  y: "8",
  width: "30",
  height: "31"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.91895",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#FF0000"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_11512_209233)" }, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "37.4643",
    cy: "13.7404",
    r: "14.4643",
    fill: "#C64D51"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "4.24993",
    cy: "37.3117",
    r: "21.9643",
    fill: "#E13E49"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter1_d_11512_209233)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.0265 14.1128C14.5642 14.1128 14.1207 14.2965 13.7938 14.6234C13.4669 14.9503 13.2832 15.3938 13.2832 15.8561V21.2313C13.2832 21.823 13.7629 22.3027 14.3546 22.3027C14.9464 22.3027 15.4261 21.823 15.4261 21.2313V16.2556H20.4017C20.9934 16.2556 21.4731 15.776 21.4731 15.1842C21.4731 14.5925 20.9934 14.1128 20.4017 14.1128H15.0265ZM25.7768 14.1128C25.1851 14.1128 24.7054 14.5925 24.7054 15.1842C24.7054 15.776 25.1851 16.2556 25.7768 16.2556H30.7524V21.2313C30.7524 21.823 31.2321 22.3027 31.8239 22.3027C32.4156 22.3027 32.8953 21.823 32.8953 21.2313V15.8561C32.8953 15.3938 32.7117 14.9503 32.3847 14.6234C32.0579 14.2965 31.6144 14.1128 31.152 14.1128H25.7768ZM31.8239 25.535C32.4156 25.535 32.8953 26.0147 32.8953 26.6064V31.9816C32.8953 32.444 32.7117 32.8874 32.3847 33.2143C32.0579 33.5413 31.6144 33.7249 31.152 33.7249H25.7768C25.1851 33.7249 24.7054 33.2452 24.7054 32.6534C24.7054 32.0617 25.1851 31.582 25.7768 31.582H30.7524V26.6064C30.7524 26.0147 31.2321 25.535 31.8239 25.535ZM15.4261 26.6064C15.4261 26.0147 14.9464 25.535 14.3546 25.535C13.7629 25.535 13.2832 26.0147 13.2832 26.6064V31.9816C13.2832 32.444 13.4669 32.8874 13.7938 33.2143C14.1208 33.5413 14.5642 33.7249 15.0265 33.7249H20.4017C20.9934 33.7249 21.4731 33.2452 21.4731 32.6534C21.4731 32.0617 20.9934 31.582 20.4017 31.582H15.4261V26.6064Z",
    fill: "white"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.87 19.5013C16.87 19.0082 17.2697 18.6084 17.7629 18.6084C18.256 18.6084 18.6557 19.0082 18.6557 19.5013V28.3364C18.6557 28.8294 18.256 29.2292 17.7629 29.2292C17.2697 29.2292 16.87 28.8294 16.87 28.3364V19.5013ZM29.1364 19.5013C29.1364 19.0082 28.7366 18.6084 28.2435 18.6084C27.7504 18.6084 27.3506 19.0082 27.3506 19.5013V28.3364C27.3506 28.8294 27.7504 29.2292 28.2435 29.2292C28.7366 29.2292 29.1364 28.8294 29.1364 28.3364V19.5013ZM25.0427 18.6084C25.5358 18.6084 25.9356 19.0082 25.9356 19.5013V24.6554C25.9356 25.1485 25.5358 25.5483 25.0427 25.5483C24.5496 25.5483 24.1499 25.1485 24.1499 24.6554V19.5013C24.1499 19.0082 24.5496 18.6084 25.0427 18.6084ZM24.1499 28.3364C24.1499 28.8295 24.5496 29.2292 25.0427 29.2292C25.5358 29.2292 25.9356 28.8295 25.9356 28.3364V27.9348C25.9356 27.4417 25.5358 27.0419 25.0427 27.0419C24.5496 27.0419 24.1499 27.4417 24.1499 27.9348V28.3364ZM21.3203 18.6084C21.8134 18.6084 22.2131 19.0082 22.2131 19.5013V24.6554C22.2131 25.1485 21.8134 25.5483 21.3203 25.5483C20.8272 25.5483 20.4274 25.1485 20.4274 24.6554V19.5013C20.4274 19.0082 20.8272 18.6084 21.3203 18.6084ZM20.4274 28.3364C20.4274 28.8295 20.8272 29.2292 21.3203 29.2292C21.8134 29.2292 22.2131 28.8295 22.2131 28.3364V27.9348C22.2131 27.4417 21.8134 27.0419 21.3203 27.0419C20.8272 27.0419 20.4274 27.4417 20.4274 27.9348V28.3364Z",
    fill: "#EABCBE"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_d_11512_209233",
    x: "1",
    y: "1.91895",
    width: "44",
    height: "44",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset"),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.721569 0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0.5 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209233"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209233",
      result: "shape"
    })
  ]),
  /*#__PURE__*/_createVNode("filter", {
    id: "filter1_d_11512_209233",
    x: "7.28571",
    y: "13.9189",
    width: "31.4286",
    height: "31.4286",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "5.71429" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2.85714" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209233"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209233",
      result: "shape"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}